export enum LanguageList {
  ENGLISH = 1,
  CHINESE = 2,
}
